var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ApiService } from '../../../service/api.service';
import { ConfigService } from '../../../service/config.service';
import { ColumnBaseService } from '../base/columnbase.service';
var HtmlEditorComponent = /** @class */ (function (_super) {
    __extends(HtmlEditorComponent, _super);
    function HtmlEditorComponent(service, baseService, apiService, config) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.apiService = apiService;
        _this.config = config;
        _this.s2 = '<select class="s2-media formSelect formSelect-select2 form_li-w200"></select>';
        _this.assets = _this.config.config['assets_base'] || '';
        return _this;
    }
    HtmlEditorComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    HtmlEditorComponent.prototype.ngAfterViewInit = function () {
        this.element = this.editorElement.nativeElement;
        this.setQuill();
        this.setValue();
    };
    HtmlEditorComponent.prototype.setQuill = function () {
        this.editor = new Quill(this.element, this.setOptions());
        var media = this.element.parentElement.querySelector('.ql-media');
        if (media) {
            media.innerHTML = this.s2;
        }
        this.setSelect2();
        var self = this;
        this.editor.on('text-change', function () {
            self.onChange(self.element.querySelector('.ql-editor').innerHTML);
        });
        var toolbar = this.element.parentElement.querySelector('.ql-toolbar');
        if (toolbar) {
            if (this.col.readonly) {
                toolbar.style['pointer-events'] = 'none';
            }
            else {
                toolbar.style['pointer-events'] = 'auto';
            }
        }
    };
    HtmlEditorComponent.prototype.setOptions = function () {
        var options = new Options();
        var tool = {};
        if (this.col.readonly) {
            options.readOnly = true;
        }
        if (this.col.params) {
            if (this.col.params.placeholder) {
                options.placeholder = this.col.params.placeholder;
            }
            if (this.col.params.toolbar) {
                tool = this.col.params.toolbar;
            }
        }
        var toolbar = [];
        if (tool['header'] !== false) {
            toolbar.push([{ 'header': [] }]);
        }
        var t1 = [];
        if (tool['bold'] !== false) {
            t1.push('bold');
        }
        if (tool['italic'] !== false) {
            t1.push('italic');
        }
        if (tool['underline'] !== false) {
            t1.push('underline');
        }
        if (tool['strike'] !== false) {
            t1.push('strike');
        }
        if (t1.length > 0) {
            toolbar.push(t1);
        }
        var t2 = [];
        if (tool['color'] !== false) {
            t2.push({ 'color': [] });
        }
        if (tool['background'] !== false) {
            t2.push({ 'background': [] });
        }
        if (t2.length > 0) {
            toolbar.push(t2);
        }
        var t3 = [];
        if (tool['super'] !== false) {
            t3.push({ 'script': 'super' });
        }
        if (tool['sub'] !== false) {
            t3.push({ 'script': 'sub' });
        }
        if (t3.length > 0) {
            toolbar.push(t3);
        }
        var t4 = [];
        if (tool['ordered'] !== false) {
            t4.push({ 'list': 'ordered' });
        }
        if (tool['bullet'] !== false) {
            t4.push({ 'list': 'bullet' });
        }
        if (t4.length > 0) {
            toolbar.push(t4);
        }
        if (tool['link'] !== false) {
            toolbar.push(['link']);
        }
        if (tool['image'] !== false) {
            toolbar.push(['image', { 'media': [] }]);
        }
        if (tool['clean'] !== false) {
            toolbar.push(['clean']);
        }
        var self = this;
        var handlers = {
            image: function (value) {
                self.s2Element.select2('open');
            },
            media: function (value) {
            }
        };
        options.modules = { toolbar: { container: toolbar, handlers: handlers } };
        return options;
    };
    HtmlEditorComponent.prototype.setSelect2 = function () {
        var url = this.apiService.makeUrl('/v1/gen/media-m-service');
        this.s2Element = $('.s2-media');
        var self = this;
        this.s2Element.select2({
            ajax: {
                delay: 300,
                dataType: 'json',
                url: url,
                xhrFields: { withCredentials: true },
                data: function (params) {
                    var predicateList = [];
                    predicateList.push({
                        or: [
                            { operator: 'suffix', name: 'file', value: '.jpeg' },
                            { operator: 'suffix', name: 'file', value: '.jpg' },
                            { operator: 'suffix', name: 'file', value: '.png' },
                            { operator: 'suffix', name: 'file', value: '.gif' },
                            { operator: 'suffix', name: 'file', value: '.JPEG' },
                            { operator: 'suffix', name: 'file', value: '.JPG' },
                            { operator: 'suffix', name: 'file', value: '.PNG' },
                            { operator: 'suffix', name: 'file', value: '.GIF' }
                        ]
                    });
                    if (typeof params.term !== 'undefined' && params.term !== null && params.term !== '') {
                        predicateList.push({
                            and: [
                                { operator: 'like', name: 'title', value: params.term }
                            ]
                        });
                    }
                    var q = {
                        predicateList: predicateList,
                        orderByList: [{ name: 'cdate', direction: 'desc' }],
                        limit: 10,
                        offset: params.page ? (params.page - 1) * 10 : 0,
                    };
                    var query = {
                        query: JSON.stringify(q),
                        page: params.page
                    };
                    return query;
                },
                processResults: function (data, params) {
                    var options = [];
                    for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        options.push({
                            id: item.id,
                            text: item.file,
                            file: self.assets + item.file,
                            title: item.title,
                            alt: item.alt
                        });
                    }
                    params.page = params.page || 1;
                    return {
                        results: options,
                        pagination: {
                            more: (params.page * 10) < data.totalRowCount
                        }
                    };
                },
                transport: function (params, success, failure) {
                    var $success = function (data, textStatus, jqXHR) {
                        self.apiService.checkBuildNoStr(jqXHR.getResponseHeader('x-pg-spa-buildno'));
                        success(data);
                    };
                    var $failure = function (jqXHR) {
                        var checkBuildNo = self.apiService.checkBuildNoStr(jqXHR.getResponseHeader('x-pg-spa-buildno'));
                        if (checkBuildNo && jqXHR.status === 401) {
                            self.s2Element.select2('close');
                            self.apiService.onUnauthorized(jqXHR.responseJSON);
                        }
                        failure();
                    };
                    var $request = $.ajax(params);
                    $request.then($success);
                    $request.fail($failure);
                    return $request;
                }
            },
            templateResult: this.formatResult
        });
        this.s2Element.on('select2:open', function (e) {
            self.editor.focus();
        });
        this.s2Element.on('select2:select', function (e) {
            if (e['params'] && e['params']['data']) {
                var data = e['params']['data'];
                var img = '<img src="' + data.file + '" alt="' + (data.alt || '') + '" title="' + (data.title || '') + '"/>';
                self.editor.focus();
                var range = self.editor.getSelection();
                var index = 0;
                if (range) {
                    index = range.index;
                }
                self.editor.clipboard.dangerouslyPasteHTML(index, img);
                self.editor.focus();
            }
            self.s2Element.val(null).trigger('change');
        });
    };
    HtmlEditorComponent.prototype.formatResult = function (state) {
        if (state.file) {
            var $state = $('<span><img src="' + state.file + '" alt="' + (state.alt || '') + '" style="width: 50px;"/>  ' + (state.title || '') + '</span>');
            return $state;
        }
        return null;
    };
    ;
    HtmlEditorComponent.prototype.ngOnChanges = function (changes) {
        var changeValFlg = this.changeValFlg;
        _super.prototype.ngOnChanges.call(this, changes);
        if (!changeValFlg) {
            this.setValue();
        }
    };
    HtmlEditorComponent.prototype.setValue = function () {
        var val = this.val;
        if (this.element && (typeof val === 'undefined' || val === null || val === '')) {
            val = '<p><br></p>';
            this.onChange(val, false);
        }
        if (this.editor) {
            this.element.parentElement.querySelector('.ql-toolbar').remove();
            this.element.innerHTML = val;
            this.setQuill();
        }
    };
    HtmlEditorComponent.prototype.onChange = function (e, changeFlg) {
        if (changeFlg === void 0) { changeFlg = true; }
        _super.prototype.onChange.call(this, e, changeFlg);
    };
    HtmlEditorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-htmleditor',
                    template: '<div style="height: 100%" [key]="key" [col]="col" columnDir><div #editor></div></div>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    HtmlEditorComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ApiService },
        { type: ConfigService }
    ]; };
    HtmlEditorComponent.propDecorators = {
        editorElement: [{ type: ViewChild, args: ['editor',] }]
    };
    return HtmlEditorComponent;
}(ColumnBaseComponent));
export { HtmlEditorComponent };
var Options = /** @class */ (function () {
    function Options() {
        this.theme = 'snow';
    }
    return Options;
}());
// quill Overwriting formats/image
var Image = Quill.import('formats/image');
var ATTRIBUTES = [
    'alt',
    'height',
    'width',
    'title'
];
var CustomImageModule = /** @class */ (function (_super) {
    __extends(CustomImageModule, _super);
    function CustomImageModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomImageModule.formats = function (domNode) {
        return ATTRIBUTES.reduce(function (formats, attribute) {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    };
    CustomImageModule.prototype.format = function (name, value) {
        if (ATTRIBUTES.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            }
            else {
                this.domNode.removeAttribute(name);
            }
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    return CustomImageModule;
}(Image));
Quill.register('formats/image', CustomImageModule);
//# sourceMappingURL=html-editor.component.js.map